import { render } from "./AdminScholarship.vue?vue&type=template&id=428347b3"
import script from "./AdminScholarship.vue?vue&type=script&lang=js"
export * from "./AdminScholarship.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__